import router from '@/router'
import { mapTypes } from '@/interfaces/enums'
import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { useAppStore } from '@/stores'

export const goToLink = (url: string | undefined, theme?: string, pageName?: string) => {
  if (url !== undefined) {
    document.title = pageName + ' - ' + theme
    router.push(url)
  }
}

export function getWebAppUrl() {
  let url = ''
  if (localStorage.getItem('webAppUrl') !== null) {
    if (import.meta.env.VITE_ENVIRONMENT === 'local') {
      url = 'http://' + localStorage.getItem('webAppUrl') + ':5173'
    } else {
      url = 'https://' + localStorage.getItem('webAppUrl')
    }
  }
  return url
}

export const handleExternLink = (to: string, newWindow: boolean) => {
  const appStore = useAppStore()

  if (to.includes('http://') || to.includes('https://')) {
    //Extern links
    if (newWindow === true) {
      openUrl(to, false, '_blank', '')
      return
    } else {
      openUrl(to, false, '_self', '')
      return
    }
  } else if (to.includes('/media')) {
    //All media items
    openUrl(appStore.apiUrl + to, true)
    return
  }
}

export function openUrl(
  url: string | undefined,
  disableNativeMethod: boolean,
  target?: string,
  features?: string
) {
  if (url === undefined) {
    return
  }
  if (Capacitor.isNativePlatform() && disableNativeMethod === false) {
    Browser.open({ url: url })
  } else {
    window.open(url, target, features)
  }
}

export const appendApiUrlToHref = (text: string, apiUrl: string) => {
  text = text.replace('&amp;shy;', '&shy;')

  if (text !== undefined && text !== null && text.includes('href')) {
    const parser = new DOMParser()

    const htmlText = parser.parseFromString(text, 'text/html')

    const anchorTags = htmlText.querySelectorAll('a')

    anchorTags.forEach(function (innerText) {
      //Checks to see if href contains media
      if (innerText.outerHTML.includes('/media/')) {
        //Get orignal href value, and append apiUrl
        const href = innerText.getAttribute('href')

        //Update href with new updated href containing apiUrl
        innerText.setAttribute('href', apiUrl + href)
      }
    })

    return (text = htmlText.body.innerHTML)
  } else {
    return text
  }
}

export function resolveApiUrl(envVariable: string): string | undefined {
  return import.meta.env[envVariable] ? (import.meta.env[envVariable] as string) : undefined
}

export const openAddressLink = (type: mapTypes, address: string) => {
  const destination = encodeURIComponent(address)

  if (destination && destination !== '') {
    let url = ''

    switch (type) {
      case mapTypes.apple: {
        url = `https://maps.apple.com/?q=${destination}`
        break
      }
      case mapTypes.generic: {
        url = `geo:0,0?q=${destination}`
        break
      }
      default: {
        url = `https://www.google.com/maps/search/?api=1&query=${destination}`
        break
      }
    }

    window.open(url)
  }
}
